import * as IconSelector from '../icons';

// Constantes exportadas
export const STATE_ARQUETA_ALTA_CON_CONTADOR = 'Alta con contador';
export const STATE_ARQUETA_ALTA_SIN_CONTADOR = 'Alta sin contador';
export const STATE_ARQUETA_BAJA_CON_ARQUETA = 'Baja con arqueta';
export const STATE_ARQUETA_BAJA_SIN_ARQUETA = 'Baja sin arqueta';

// Definición del enum
export const statesArqueta = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido un estado para la arqueta',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_ARQUETA_ALTA_CON_CONTADOR,
        label: 'Alta con contador',
        description: 'Alta con contador',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_ARQUETA_ALTA_SIN_CONTADOR,
        label: 'Alta sin contador',
        description: 'Alta sin contador',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_ARQUETA_BAJA_CON_ARQUETA,
        label: 'Baja con arqueta',
        description: 'Baja con arqueta',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_ARQUETA_BAJA_SIN_ARQUETA,
        label: 'Baja sin arqueta',
        description: 'Baja sin arqueta',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    }
];
